
























































































































































































































import { AuthErrorCode, Error, List } from '@luxtag/papybase';
import { Component, Mixins } from 'vue-property-decorator';
import { remove, sortBy } from 'lodash';
import GAErrorEvent from '@/mixins/vue/gAnalytics/GAErrorEvent';
import GoalIntegrationMixin from '@/mixins/vue/GoalIntegrationMixin';
import IndustryIntegrationMixin from '@/mixins/vue/IndustryIntegrationMixin';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import { MUTATE_AUTH } from '@/store/modules/auth';
import RecSelectField from '@/components/global/input/RecSelectField.vue';
import RecTextField from '@/components/global/input/RecTextField.vue';
import SourceIntegrationMixin from '@/mixins/vue/SourceIntegrationMixin';
import { auth } from '@/plugins/papybase/papybaseInit';

interface Selected {
    value?: any;
    text?: string;
}

interface Form {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    companyName: string;
    industry: number | undefined;
    industryOther: string;
    source: number | undefined;
    sourceOther: string;
    goal: number | undefined;
    goalOther: string;
}

@Component({
    components: {
        RecTextField,
        RecSelectField,
    },
    $_veeValidate: { validator: 'new' },
})
export default class SignupForm extends Mixins(
    IsMobileMixin, IndustryIntegrationMixin, GoalIntegrationMixin, SourceIntegrationMixin,
    GAErrorEvent,
) {
    public showProgress= false;

    public showPassword = false;

    public form: Form = {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        companyName: '',
        industry: undefined,
        industryOther: '',
        source: undefined,
        sourceOther: '',
        goal: undefined,
        goalOther: '',
    }

    public dictionary = {
        en: {
            attributes: {
                firstName: 'first name',
                lastName: 'last name',
                companyName: 'company name',
                industryOther: 'industry name',
                sourceOther: 'source',
            },
        },
    };

    public signUpWithGoogle() {
        this.signUpEvent('register merchant with google account', 'Sign up with Google');
        const that = this;
        this.$gAuth.signIn()
            .then(async (user: any) => {
                that.showProgress = true;
                // On success do something, refer to https://developers.google.com/api-client-library/javascript/reference/referencedocs#googleusergetid
                const { access_token } = user.getAuthResponse();
                try {
                    const authInfo = await auth.signInWithGoogle(access_token);
                    const theUser: any = authInfo;
                    theUser.login = true;
                    theUser.isLoginByEmail = false;
                    this.$store.commit(MUTATE_AUTH, theUser);
                    this.$router.replace('/');
                } catch (error) {
                    console.error(error);
                } finally {
                    that.showProgress = false;
                }
            })
            .catch((error: any) => {
                console.error(error);
                this.errorEvent('gAuth.signIn', error);
                // On fail do something
            });
    }

    public async signUp() {
        // prevent for sign in to work while progress is show up
        if (this.showProgress) return;

        this.signUpEvent('register merchant', 'Create Account');

        const valid = await this.$validator.validateAll();
        if (valid) {
            this.showProgress = true;
            auth.createMerchant(
                this.form.email,
                this.form.password,
                this.form.firstName,
                this.form.lastName,
                this.form.companyName,
                this.form.industry,
                this.form.goal,
                this.form.source,
            ).then((res) => {
                this.$router.push({
                    name: 'email-confirmation',
                    query: {
                        email: this.form.email,
                    },
                });
            }).catch((err) => {
                this.errorEvent('createMerchant', err);
                this.addAuthError(err);
            }).finally(() => {
                this.showProgress = false;
            });
        }
    }

    public addAuthError(error:Error) {
        let fieldName = '';

        switch (error.code) {
                case AuthErrorCode.USER_NOT_FOUND:
                    fieldName = 'password';
                    break;
                case AuthErrorCode.INVALID_EMAIL:
                    fieldName = 'email';
                    break;
                case AuthErrorCode.INVALID_IDENTIFIER:
                    fieldName = 'email';
                    break;
                case AuthErrorCode.INVALID_PASSWORD:
                    fieldName = 'password';
                    break;
                case AuthErrorCode.INVALID_USERNAME:
                    fieldName = 'email';
                    break;
                case AuthErrorCode.NOT_MERCHANT:
                    fieldName = 'email';
                    break;
                default:
                    fieldName = 'email';
                    break;
        }

        const field = this.$validator.fields.find({ name: fieldName });
        if (!field) return;

        this.errors.add({
            id: field.id,
            field: field.name,
            msg: error.message,
        });
    }

    public mounted() {
        this.$validator.localize(this.dictionary);
    }

    public onSignupSuccessDialog() {
        this.$router.replace('/');
    }

    public signUpEvent(action: string, label: any) {
        this.$ga.event('Signup', 'click', action, label);
    }

    get industries() {
        const theIndustries = sortBy(this.$store.getters.getIndustries, ['text']);
        const theOthers = remove(theIndustries, theIndustry => theIndustry.text === 'Others');
        if (theOthers.length > 0) theIndustries.push(theOthers[0]);
        return theIndustries;
    }

    get goals() {
        return this.$store.getters.getGoals;
    }

    get sources() {
        return this.$store.getters.getSources;
    }
}
